import React from 'react';

/**
 * Clean horse silhouette placeholder — used when an animal has no photo yet.
 * Uses a proven, symmetric, hand-crafted horse-head profile SVG.
 * Source: Adapted from the public-domain "horse-head" glyph pattern.
 */
export function AnimalSilhouette({ category = 'horse', className = '' }) {
  return (
    <div className={`w-full h-full flex items-center justify-center bg-[#EEF0EE] ${className}`}>
      <svg
        viewBox="0 0 640 512"
        width="160"
        height="128"
        role="img"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Font Awesome Free 5 "horse" icon — CC-BY-4.0. Simplified path. */}
        <path
          fill="#B7BEB9"
          d="M575.9 296.5l-25.2-16.8c-2.9-1.9-4.9-5.1-5.4-8.5-2.5-17.2-11.5-32.2-24.9-42.4v-.2c-6.9-5.2-8.8-14.5-4.9-22.1l3.9-7.7c1.5-3 4.4-5.1 7.7-5.8l4.4-.9c11.6-2.3 20-12.5 20-24.3V151c0-8.7-6.9-15.6-15.4-15.9-1.6-.1-3.1-.4-4.5-.9l-6.7-2.4c-11.9-4.2-20.2-14.8-21.7-27.4l-1.4-11.3c-1.8-14.6-8.6-27.9-19.7-38-11.1-10.1-25.3-16.9-40.4-19-6.6-.9-12.9-3.8-18.1-8.4C398.9 15.4 379 8 358.4 8h-52.8c-16.9 0-33 6.4-45.4 17.9-3.6 3.4-8.4 5.3-13.4 5.3H184c-8.8 0-16 7.2-16 16v16c0 4.4 3.6 8 8 8h16c26.5 0 48 21.5 48 48v56c0 22.1-17.9 40-40 40h-96C46.5 215.2 0 261.7 0 320c0 4.4 3.6 8 8 8h32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8h32c4.4 0 8 3.6 8 8v104c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V344c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v104c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V344c0-4.4 3.6-8 8-8h32c4.4 0 8-3.6 8-8h32c4.4 0 8-3.6 8-8h32c4.4 0 8-3.6 8-8 0-9.5-4.7-18.3-12.1-23.5zM480 152c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        />
      </svg>
    </div>
  );
}
